import { Col, Row } from 'reactstrap'
import { H6 } from '../../../../../AbstractElements'
import { useAuth } from '../../../../../hooks/useAuth'
import { useTranslation } from 'react-i18next'

const ProfileContact = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  // Datos de contacto del usuario
  const contactData = [
    {
      icon: 'phone',
      title: t("Teléfono"),
      detail: user?.phone 
        ? `${user.country_code_phone || ''} ${user.phone}`.trim()
        : t("No disponible")
    },
    {
      icon: 'map-marker',
      title: t("País"),
      detail: user?.country?.name || user?.country?.code || t("No disponible")
    }
  ];

  return (
    <Col sm="6" lg="4" className="order-sm-2 order-xl-2">
      <Row>
        {contactData.map((data, i) => (
          <Col md="6" key={i}>
            <div className="ttl-info text-start">
              <H6>
                <i className={`fa fa-${data.icon}`} /> {data.title}
              </H6>
              <span>{data.detail}</span>
            </div>
          </Col>
        ))}
      </Row>
    </Col>
  )
}

export default ProfileContact